import React from "react";
import "./Account.css";
import ProfileCard from "./ProfileCard/ProfileCard";
import WalletActions from "./WalletActions/WalletActions";
import MenuGrid from "./MenuGrid/MenuGrid";
import ServiceCenter from "./ServiceCenter/ServiceCenter";
import BottomNav from "./BottomNav/BottomNav";
import Tab_list from "../Common/Common_Component/Tab_list/Tab_list";

function Account() {
  const tabListData = [
    {
      type: "link",
      name: "Notification",
      image: "/assets/images/icons/envolope.png",
         link: "/notifications",
    },
    {
      type: "link",
      name: "Gifts",
      image: "/assets/images/icons/gift.png",
      link: "/gift",
    },
    {
      type: "link",
      name: "Game Statistics",
      image: "/assets/images/icons/Graph.png",
      link: "/game-statistics",
    },
    {
      type: "copy",
      name: "Language",
      image: "/assets/images/icons/web.png",
      value: "English",
    },
  ];
  return (
    <>
      <section className="Account">
        <div className="account-container">
          <div className="container">
            <ProfileCard />
            <MenuGrid />
            <Tab_list listItems={tabListData} />
            <ServiceCenter />
            <BottomNav />
          </div>
        </div>
      </section>
    </>
  );
}

export default Account;
